module.exports = __webpack_public_path__ + "img/nft.b414d048.png";